import {AbstractControl, ValidationErrors} from '@angular/forms';
/**
 * @param {?} c
 * @return {?}
 */
export function isArray(c: AbstractControl): null | ValidationErrors {
  if (c.value) {
    const /** @type {?} */ error = {
      isArray: {
        message: 'signature is no array'
      }
    };

    const /** @type {?} */ arrayConstructor = [].constructor;
    if (c.value.constructor !== arrayConstructor) {
      return error;
    }
  }
  return null;
}
